import _Object$assign from 'babel-runtime/core-js/object/assign';
export default function convertFieldProperty(component) {
  var properties = component;
  var field = properties['extendParams'] || {};
  field.id = component.code;
  field.displayUnit = properties.displayUnit || properties.unit && properties.unit.name || '';
  field.unitName = field.displayUnit;

  // field.values = properties.values || [];
  field.valueType = properties.valueType;
  field.globalKey = properties.globalKey;

  try {
    field.remark = JSON.parse(field.remark).tip;
  } catch (e) {
    field.remark = '';
  }
  field.upgrade = field.upgrade == 'true' || field.upgrade == true;
  field.downgrade = field.downgrade == 'true' || field.downgrade == true;
  field.originShow = field.show == 'true' || field.show == true;
  field.show = field.originShow;
  field.needTransmit = field.needTransmit == 'true' || field.needTransmit == true;

  var ret = _Object$assign({}, properties, field, {
    extendParams: null
  });
  ret.conversion = field.conversion || 1;

  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/convertField/convertFieldProperty.js
// module id = 178
// module chunks = 0